import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { GET_VENDOR_BY_BOOKING, GET_VENDOR_BY_BOOKING_SUCCESS, GET_VENDOR_BY_BOOKING_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getVendorByBooking({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/get-vendors`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_VENDOR_BY_BOOKING_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_VENDOR_BY_BOOKING_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_VENDOR_BY_BOOKING_ERROR, payload: error });
  }
}

export function* watchGetVendorsByBooking() {
  yield takeEvery(GET_VENDOR_BY_BOOKING, getVendorByBooking);
}

function* getVendorsByBookingSaga() {
  yield all([fork(watchGetVendorsByBooking)]);
}

export default getVendorsByBookingSaga;
